export const CART_ITEM_TYPES = {
  ADDON: 'Ecommerce::Products::MembershipAddon',
  DONATION: 'Donation::Campaign',
  EVENT_ADDON: 'Ecommerce::Products::EventAddon',
  MEMBERSHIP: 'Memberships::Type',
  PAYMENT_OPTION: 'Ecommerce::PaymentOption',
  PROMO_CODE: 'Ecommerce::PromoCode',
  TICKET: 'NetworkEvents::Ticket',
};

export const SUB_CART_ITEM_TYPES = {
  DONATION: 'donation',
  STANDALONE_ADDON: 'standalone_addon',
  SUB_ADDON: 'sub_addon',
  TICKET: 'ticket',
};

export const CART_STATUS = {
  DRAFT: 'draft',
  PAID: 'paid',
};
